module.exports = __webpack_public_path__ + "media/images/brand/logo/tfs_logo_cow-9f701760d9d962d7151c22000644bc12.svg";